import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { vModelDynamic as _vModelDynamic, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "custom-input" }
const _hoisted_2 = ["id", "type"]


  import { BaseIcon, CrossIcon } from "@/components/icons";
  
export default /*#__PURE__*/_defineComponent({
  __name: 'CustomInput',
  props: /*#__PURE__*/_mergeModels({
    type: { default: "text" },
    inputClass: { default: null },
    inputId: { default: null },
    withClear: { type: Boolean, default: false },
    placeholder: { default: null }
  }, {
    "modelValue": { type: [String, Number, null, Boolean] },
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {

  const props = __props;

  const modelValue = _useModel<string | number | null | boolean>(__props, "modelValue");

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("input", {
      id: props.inputId,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modelValue).value = $event)),
      type: props.type,
      class: _normalizeClass(props.inputClass),
      onKeyup: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"])),
      onKeydown: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
    }, null, 42, _hoisted_2), [
      [_vModelDynamic, modelValue.value]
    ]),
    (_ctx.withClear)
      ? (_openBlock(), _createBlock(_unref(BaseIcon), {
          key: 0,
          class: "input-clear",
          "icon-name": "cross",
          width: "14",
          height: "14",
          viewBox: "0 0 28.945 28.945",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (modelValue.value = null))
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(CrossIcon))
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})